import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconWalletRefund';
/** Renders an SVG icon. */
const SvgWalletRefund = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M22 18v-2h5v2zM20.283 5.548a1 1 0 0 1 1.252.717L21.97 8H11.944zM29 16c0-.74-.403-1.383-1-1.73V11a3 3 0 0 0-3-3h-1.001a1 1 0 0 0-.03-.242l-.493-1.979a3 3 0 0 0-3.757-2.15L4.718 8.04A1 1 0 0 0 4 9v14a3 3 0 0 0 3 3h8a1 1 0 1 0 0-2H7a1 1 0 0 1-1-1V10h19a1 1 0 0 1 1 1v3h-4a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2z"
      />
      <path
        fill="currentColor"
        d="M26 27.472c0-.813-.659-1.472-1.472-1.472h-3.114l1.293 1.293a1 1 0 1 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 1 1 1.414 1.414L21.414 24h3.114a3.472 3.472 0 0 1 1.553 6.578l-.634.317a1 1 0 0 1-.894-1.79l.633-.316c.5-.25.814-.76.814-1.317"
      />
    </svg>
  );
};
SvgWalletRefund.displayName = displayName;
export default SvgWalletRefund;
